import { VehicleStatusBadge } from './VehicleListItem';
import type { Vehicle } from '../../types/vehicle';
import genericVehicleImage from '../../assets/vehicle-generic.png';

interface VehicleGraphicProps {
  status: Vehicle['status'];
  /** @default '160px' */
  height?: string;
  /** El detalle ya trae su propio badge en el encabezado del modal; la tarjeta de listado no. */
  showStatusBadge?: boolean;
  /** "Imagen ilustrativa" en una esquina. Solo tiene sentido donde hay espacio (el detalle). */
  showCaption?: boolean;
}

// issue #122: imagen GENÉRICA de un vehículo de carga. El schema `Vehicle` no
// trae ningún campo de foto, así que esta imagen es la misma para toda la flota
// y NO representa al vehículo real — por eso el `alt` y el rótulo opcional dicen
// "ilustrativa". Si algún día backend entrega una foto por vehículo, esta pieza
// es donde se sustituye (quedaría como imagen de respaldo).
//
// Es una foto de producto sobre fondo blanco: se muestra sobre un panel blanco en
// ambos temas, como una fotografía. Recolorearla o dejar que el fondo del tema se
// filtre a través del PNG la ensuciaría.
export function VehicleGraphic({ status, height = '160px', showStatusBadge = true, showCaption = false }: VehicleGraphicProps) {
  return (
    <div
      className="vehicle-detail-modal__graphic"
      style={{
        position: 'relative',
        width: '100%',
        height,
        borderRadius: 'var(--radius-lg)',
        background: '#FFFFFF',
        border: '1px solid var(--border)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <img
        src={genericVehicleImage}
        alt="Vehículo de carga (imagen ilustrativa)"
        width={746}
        height={438}
        loading="lazy"
        decoding="async"
        draggable={false}
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />

      {showStatusBadge && (
        <div style={{ position: 'absolute', top: '12px', right: '12px', zIndex: 2 }}>
          <VehicleStatusBadge status={status} />
        </div>
      )}

      {showCaption && (
        <span style={{ position: 'absolute', left: '10px', bottom: '6px', fontSize: '10px', fontWeight: 600, color: '#6B7280' }}>
          Imagen ilustrativa
        </span>
      )}
    </div>
  );
}
